import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { MerchantTitle } from 'app/MerchantTitle';
import { ActivateForm } from 'components/user/ActivateForm';
import { getPendingSignupIdentity } from 'components/user/localAuth';
import { RegisterResult } from 'components/user/SignUpForm';
import { MuiAppBar } from 'lib/appbar/MuiAppBar';
import { useLocalHistory } from 'lib/useLocalHistory';
import { ROUTES } from './routes';

export const ActivatePage: React.FC = () => {
    const { t } = useTranslation();
    const { replace } = useLocalHistory();
    const location = useLocation();
    const locationState = location.state as { user?: RegisterResult } | null;

    const handleBack = React.useCallback(() => {
        // Replace rather than push — pushing grows history with alternating sign-up/activate
        // entries, so the app-bar close (navigate(-1)) can never escape the pair (PEP-20658).
        // SignUpForm expects a plain User in `state.user`; the register result wraps it.
        replace(ROUTES.USER.REGISTER, {}, '', {
            user: locationState?.user?.user,
            identity: getPendingSignupIdentity()
        });
    }, [locationState, replace]);

    return (
        <>
            <MerchantTitle title={t('ONBOARDING_ACTIVATION_TITLE')} />
            <MuiAppBar title={t('ONBOARDING_ACTIVATION_TITLE')} onBack={handleBack} />
            <ActivateForm />
        </>
    );
};
